import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [51.507173, -0.128117, 24.8],
  [51.507313, -0.128299, 24.4],
];

export default stream;
